import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_ADVANCED_API = registerFeatureWithDescription({
    numericalId: 11,
    id: "Advanced-API",
    name: "Advanced API",
    internalOnly: true,
    readyForProduction: true,
    descriptionLines: ["Allows additional settings on sharelinks which relate to exposing more data via the API"],
})

export const FEATURE_FLAG_API_EXPOSE_ZEROU = registerFeatureWithDescription({
    numericalId: 11.1,
    id: "api-expose-zerou",
    name: "Advanced API > Expose ZeroU Tasks",
    internalOnly: true,
    readyForProduction: true,
    descriptionLines: ["Allows zeroU tasks to be pulled via the API"],
})

export const FEATURE_FLAG_API_USE_UNIQUE_CODE = registerFeatureWithDescription({
    numericalId: 11.2,
    id: "api-use-unique-code",
    name: "Advanced API > Use Unique Code",
    internalOnly: true,
    readyForProduction: true,
    descriptionLines: [
        "Allows the unique code on custom schedules to override the SFG20 generated code in the API response",
    ],
})
